module.exports = __webpack_public_path__ + "static/media/chris-attribute-cloud.1eae609f.png";